import { render, staticRenderFns } from "./UploadedFileItem.vue?vue&type=template&id=2724cb01&scoped=true&"
import script from "./UploadedFileItem.vue?vue&type=script&lang=ts&"
export * from "./UploadedFileItem.vue?vue&type=script&lang=ts&"
import style0 from "./UploadedFileItem.vue?vue&type=style&index=0&id=2724cb01&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2724cb01",
  null
  
)

export default component.exports